import React from "react";
import { DIVISIONS } from "../../../src/constants.js"
import DivisionalReportsPage from "./DivisionalReportsPage.js";

export default function VillageReports() {
  return <DivisionalReportsPage division={DIVISIONS.VILLAGE}/>
};